import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';

const NotFound = () => {
  const error = useRouteError();
  const navigate = useNavigate();

  // Rendered both as a catch-all route (no error, unmatched URL) and as an
  // errorElement (e.g. a render error). Treat the absence of an error, or a
  // 404 error response, as "page not found"; anything else as a generic error.
  const is404 = !error || (isRouteErrorResponse(error) && error.status === 404);

  const title = is404 ? 'Seite nicht gefunden' : 'Es ist ein Fehler aufgetreten';
  const message = is404
    ? 'Die aufgerufene Seite existiert nicht oder wurde verschoben.'
    : 'Beim Laden dieser Seite ist ein unerwarteter Fehler aufgetreten.';

  return (
    <div className='justify-content-center row mt-5'>
      <div className='col-lg-5 col-md-7'>
        <div className='card text-center'>
          <div className='card-body py-5'>
            <FontAwesomeIcon
              icon={faCircleXmark}
              size='3x'
              className='text-muted mb-3'
            />
            <h4>{is404 ? '404' : 'Hoppla!'}</h4>
            <p className='mb-1'>
              <strong>{title}</strong>
            </p>
            <p className='text-muted'>{message}</p>
            <button
              className='btn btn-primary'
              type='button'
              onClick={() => navigate('/')}
            >
              Zurück zur Startseite
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
